import React from "react"
import * as styles from "./Styles/PCContainer.module.scss"

const PCContainer = (props) => {
  return (
    <React.Fragment>
      <div className={styles.container}>
        <BgImage />
        {props.children}
      </div>
    </React.Fragment>
  )
}

const BgImage = () => <div className={styles.bgImage}></div>

export default PCContainer
